import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pwj310Api, QueryRequest, QueryResponse } from '../../../services/pwj310Api';

export interface PWJ310QueryState {
  loading: boolean;
  result: QueryResponse | null;
  queried: boolean;
  noData: boolean;
}

export interface PWJ310QueryActions {
  runQuery: (req: QueryRequest) => Promise<void>;
  reset: () => void;
}

export function usePWJ310Query(): PWJ310QueryState & PWJ310QueryActions {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<QueryResponse | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (req: QueryRequest) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pwj310Api.query(req);
      const hasCheck1 = resp.check1Data && resp.check1Data.length > 0;
      const hasCheck2 = resp.check2Data && resp.check2Data.length > 0;
      if (hasCheck1 || hasCheck2) {
        setResult(resp);
        setNoData(false);
      } else {
        setResult(null);
        setNoData(true);
        message.info('查無符合條件的資料');
      }
      setQueried(true);
    } catch (err: unknown) {
      const axiosErr = err as { response?: { status?: number; data?: { error?: string } } };
      if (axiosErr.response?.status === 400) {
        message.error(axiosErr.response.data?.error || '查詢條件錯誤');
      } else {
        message.error('查詢失敗，請稍後再試');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, result, queried, noData, runQuery, reset };
}
